"use strict";

let language = null;

export default function loadLanguage(appProduct, viewName, langCode, partnerSubdomain) {
    // TODO: Make Async
    if (!language) {
        (function loadLang() {
            const result = $.ajax({
                type: 'GET',
                async: false,
                url: `/api/localization/?app-Product=${appProduct}&view-name=${viewName}&lang-code=${langCode}&partner-subdomain=${partnerSubdomain}`,
                dataType: 'json',
                error(e) {
                    // console.error('Error Loading Languages', e);
                    // console.log("XML reading Failed: ", e);
                },
                success(response) {
                    language = response.language;
                }
            });
        })();
    }
    return language;
}
